import PropTypes from 'prop-types';

export const propTypes = {
    size: PropTypes.string,
    color: PropTypes.string,
    borderWidth: PropTypes.string,
};
